import { useState } from 'react'
import { apiURL } from '../../utilities/URLs'
import { customerData } from '../../utilities/CustomerData'

export function ConfirmCancelApplicationModal({ setShowConfirmCancelApplication }) {
  const [cancelingApplication, setCancelingApplication] = useState(false)

  const handleCancelApplication = async () => {
    const cancelApplicationResponse = await fetch(`${apiURL}/api/cancelApplication?applicationId=${encodeURIComponent(customerData.customerAdvanceFunding.applicationId)}`)
    const cancelApplicationData = await cancelApplicationResponse.json()
    if(cancelApplicationData.response.error)
      console.error(cancelApplicationData.response.error)
    else {
      
    }
  }

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
      <div className='bg-white shadow-lg rounded-2xl p-8 text-center relative overflow-auto max-sm:h-[90%]'>
        <button disabled={cancelingApplication} onClick={() => setShowConfirmCancelApplication(false)} className='absolute right-4 top-4 text-gray-500 hover:text-gray-700 transition duration-200'>
          <svg xmlns='http://www.w3.org/2000/svg' className='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
          </svg>
        </button>
        <h2 className='text-3xl font-bold text-gray-900 mb-6'>Cancel Application</h2>
        <p className='text-gray-600 mb-4 text-lg text-start'>Are you sure you want to cancel your application?</p>
        <p className='text-gray-600 mb-8 text-lg text-start'>This process cannot be <span className='font-bold text-red-600'>UNDONE</span>.</p>
        <div className='flex justify-center gap-4'>
          <button disabled={cancelingApplication} onClick={() => null} className={`text-white font-semibold py-2 px-6 rounded-lg shadow-md transition duration-300 ${cancelingApplication ? 'bg-gray-400 : cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}>
            Confirm Cancel
          </button>
        </div>
        {cancelingApplication && (
          <div className='flex flex-row items-center justify-center gap-2'>
              <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
              <p>Canceling Application...</p>
            </div>
        )}
      </div>
    </div>
  )
}